
/**
 * Created by nijin on 5/6/17.
 */
import {Component, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {ApiKeyService} from '../../api-key.service';
import {NotificationType} from '../../../core/notify';
import {NotificationBarService} from '../../../core/notify/notification.service';
@Component({
  selector: 'nuc-remove-ip-confirmation',
  template: `
       <app-modal #popup>
  <div class="app-modal-header">
    <h3 class="modal-title red">Remove Whitelisted IP?</h3>
  </div>
  <div class="app-modal-body">
    <p>Are you sure you want to remove the following IP from whitelisted IP?</p>
    <p class="IPsToDelete text-center red"><span>{{ip.ip}}</span></p>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-secondary" (click)="close()" [disabled]="isLoading" id="rm-cancel">
        {{'COMMON.CANCEL' | translate}}</button>
      <button class="btn btn-secondary btn-red"  [disabled]="isLoading" id="rm-remove" (click)="removeIp()">
      <span *ngIf="isLoading">
          <i class="fa fa-spinner fa-spin"></i>     
     </span>
       {{'COMMON.REMOVE' | translate}}
        </button>
    </div>
  </div>
</app-modal>
 `,
  styleUrls: ['./popup.scss']

})
export class RemoveIPConfirmationComponent {

   isLoading = false;
   ip: any = {};

   @Input() apiKey: any;

  @ViewChild ('popup') popup;
  @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onReject: EventEmitter<number> = new EventEmitter<number>();

  constructor(private apiKeyService: ApiKeyService, private notifier: NotificationBarService) {

  }


  open(ip) {
    this.ip = ip;
    this.popup.open();
  }

  close() {
    this.popup.hide();
  }

  removeIp() {
      this.isLoading = true;
      const idx = this.apiKey.whitelistIps.indexOf(this.ip);
      const ips = [].concat(this.apiKey.whitelistIps);
      ips.splice(idx, 1);
      const data = {whitelistIps: ips, timeToLive: -1};
      this.apiKeyService.updateWhiteListedIp(this.apiKey.id, data)
        .subscribe( res => {
          this.isLoading = false;
          this.onAccept.emit(res.data);
          this.notifier.create({type: NotificationType.Success, message: res.status.message});
          this.close();
         },  (error) => {
          this.notifier.create({type: NotificationType.Error, message: error});
          this.isLoading = false;
        });
  }


}




// WEBPACK FOOTER //
// ./src/app/accounts/api-key/modal/remove.ip.confirmation.ts